import { useLocation, useNavigate } from 'react-router'
import {
  ChatBubbleOutlineOutlined,
  DragHandleOutlined,
  EmailOutlined,
  MobileFriendlyOutlined,
  NotificationsOffOutlined,
  PhoneOutlined,
} from '@mui/icons-material'
import { Avatar, ButtonBase, Grid, Typography, useTheme } from '@mui/material'

import useStyles from './index.styles'

interface IProps {
  user: IUserType
  idx: number
  isOwnUser: boolean
  isDragging: boolean
  canAddUsers: boolean
  isOnboarding: boolean
}

const ContactCard = (props: IProps) => {
  const { user, idx, isOwnUser, isDragging, canAddUsers, isOnboarding } = props

  const { information: { first: firstName, last: lastName } = {} } = user
  const preferences = user.preferences?.notification || []

  const classes = useStyles
  const theme = useTheme()
  const navigate = useNavigate()
  const location = useLocation()

  const doNotContact = preferences.length === 0
  const isUserSelected = location.pathname.endsWith(`/${user.id}`)

  return (
    <ButtonBase
      sx={[
        classes.contactCardButtonBase,
        { cursor: isDragging ? 'grabbing' : 'pointer' },
        isOnboarding && { borderBottom: `1px solid ${theme.palette.divider}` },
      ]}
      onClick={() => navigate(`${user.id}`, { state: location.state })}
    >
      <Grid
        container={true}
        size={12}
        spacing={1}
        sx={[classes.contactCardContainer, { backgroundColor: isUserSelected ? theme.palette.secondary.light : theme.palette.background.paper }]}
      >
        <Grid>
          <Avatar sx={classes.priorityAvatar}>
            {preferences.length > 0 ? idx + 1 : <NotificationsOffOutlined aria-label="Notification preferences are turned off" />}
          </Avatar>
        </Grid>

        <Grid container={true} sx={classes.contactDetailsColumn}>
          <Typography variant="body1" className="fs-exclude" sx={classes.contactName}>
            {firstName} {lastName} {isOwnUser && <span style={classes.youText}>(You)</span>}
          </Typography>

          <Grid container={true} sx={classes.preferencesRow}>
            {preferences.includes('phone') && <PhoneOutlined htmlColor={theme.palette.text.secondary} sx={classes.preferenceIcon} aria-label="phone" />}
            {preferences.includes('email') && <EmailOutlined htmlColor={theme.palette.text.secondary} sx={classes.preferenceIcon} aria-label="email" />}
            {preferences.includes('sms') && <ChatBubbleOutlineOutlined htmlColor={theme.palette.text.secondary} sx={classes.preferenceIcon} aria-label="sms" />}
            {preferences.includes('push') && <MobileFriendlyOutlined htmlColor={theme.palette.text.secondary} sx={classes.preferenceIcon} aria-label="push" />}
          </Grid>
        </Grid>

        <Grid container={true} sx={classes.dragHandleContainer}>
          {canAddUsers && !doNotContact && <DragHandleOutlined color="secondary" sx={{ cursor: isDragging ? 'grabbing' : 'grab' }} />}
        </Grid>
      </Grid>
    </ButtonBase>
  )
}

export default ContactCard
